export default __webpack_public_path__ + "static/laura-7f2de87206fd2efe2e9b8632284c2c21.jpg";